import { observer } from 'mobx-react'
import cx from 'classnames'

type HeadingProps = {
  size?: 'small' | 'large'
  variant?: 'default' | 'system'
  id?: string
  title: string
  subtitle?: string
}

const Heading = ({
  size = 'small',
  id,
  title,
  subtitle,
  variant = 'default',
}: HeadingProps) => {
  const TAG = size === 'small' ? 'h2' : 'h1'
  return (
    <header
      id={id}
      className={cx('heading', { [size]: size, [variant]: variant })}
    >
      <TAG className="heading-title">{title}</TAG>
      {subtitle && (
        <span className="heading-subtitle">
          {variant === 'default' ? (
            <span className="heading-gradient">{subtitle}</span>
          ) : (
            subtitle
          )}
        </span>
      )}
    </header>
  )
}

export default observer(Heading)
